// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M2.37 12.75C0.79 10.02 1.41 6.55 3.82 4.52C6.24 2.49 9.76 2.49 12.18 4.52C14.59 6.55 15.21 10.02 13.63 12.75',
  'M8 9.5L10.9 6.6',
];
